import { masks } from '@/lib/utils'

interface Props {
  isCompany?: boolean
  value: string
}

function TaxDocumentField({ isCompany = false, value }: Props) {
  if (!value) return null
  if (isCompany) {
    return value.replace(
      masks.regex.companyTaxDocument,
      (all, n1, n2, n3, n4, n5) => `${n1}.${n2}.${n3}/${n4}-${n5}`
    )
  }

  return value.replace(masks.regex.taxDocument, (all, n1, n2, n3, n4) => `${n1}.${n2}.${n3}-${n4}`)
}

export default TaxDocumentField
